import * as React from "react";
import classNames from "classnames";
import Icon from "~/components/icons/icon";
import setThemeFromImg from "~/utils/theming-utils";
import { IProduct } from "~/types/product";
// import ProductDiscountSplash from "~/components/product-discount-splash/product-discount-splash";
import ProductImage from "~/components/product-image/product-image";
import ProductImageModal from "~/components/product-image-modal/product-image-modal";
import IconButton from "~/components/icon-button/icon-button";
import IconLink from "~/components/icon-link/icon-link";

export interface IProductHeroProps extends Pick<IProduct, "imageFallbackSrc" | "imageSrcSet"> {
    // discount: IProduct["discount"];
    readBookLabel?: string;
    readBookPlayerLink?: string;
    listenToBookLabel?: string;
    listenToBookPlayerLink?: string;
    downloadCoverImageLabel?: string;
    downloadCoverImageLink?: string;
    onOpenAudioModal(): void;
    onOpenBookModal(): void;
}

export interface IProductHeroState {
    isProductImageLoaded: boolean;
    isTimeoutOver: boolean;
    isModalOpen: boolean;
}

class ProductHero extends React.Component<IProductHeroProps, IProductHeroState> {
    private productImage: HTMLImageElement;
    public state: IProductHeroState = {
        isProductImageLoaded: false,
        isTimeoutOver: false,
        isModalOpen: false
    };

    private requestAnimationFrameIndex = 0;

    public componentDidMount() {
        this.requestAnimationFrameIndex = window.requestAnimationFrame(() =>
            this.setState({ isTimeoutOver: true })
        );
    }

    public componentWillUnmount() {
        window.cancelAnimationFrame(this.requestAnimationFrameIndex);
    }

    private handleProductImageLoad() {
        this.setState({ isProductImageLoaded: true });
        setThemeFromImg(this.productImage);
    }

    public render() {
        const baseClass = "product-hero";
        const productHeroClasses = classNames(baseClass, {
            [`${baseClass}--imageIsLoaded`]: this.state.isProductImageLoaded
        });
        const graphicsClasses = classNames(`${baseClass}__graphics`, {
            [`${baseClass}__graphics--show`]: this.state.isProductImageLoaded
        });

        return (
            <>
                <div className={productHeroClasses}>
                    <div className={`${baseClass}__image-container`}>
                        <div className={`${baseClass}-background theme-bg-secondary`} />
                        {/* Mobile icon */}
                        <div className={graphicsClasses}>
                            {this.state.isProductImageLoaded && (
                                <>
                                    {global.currentSite === "ClubGyldendalDk" ? null : (
                                        <Icon
                                            className="theme-color-primary"
                                            iconId="icon_80x48_quotation-mark"
                                            viewBox="0 0 80 48"
                                        />
                                    )}
                                </>
                            )}
                        </div>
                        {this.state.isTimeoutOver && (
                            <div className={`${baseClass}__image-wrapper`}>
                                {this.props.imageSrcSet && (
                                    <ProductImage
                                        alt="Product image"
                                        onClick={() => this.setState({ isModalOpen: true })}
                                        className={`${baseClass}__image`}
                                        sizes="(max-width: 639px) calc((100vw - 48px) * 0.75), (max-width: 1039px) calc((100vw - 32px) * 0.2), 200px"
                                        srcSet={this.props.imageSrcSet}
                                        fallbackSrc={this.props.imageFallbackSrc}
                                        onLoad={() => this.handleProductImageLoad()}
                                        ref={(node: any) => {
                                            if (node) {
                                                // Required for color sampling MMS images
                                                node.crossOrigin = "Anonymous";
                                                this.productImage = node;
                                            }
                                        }}
                                    />
                                )}
                                {/* {this.props.discount && (
                                    <ProductDiscountSplash discount={this.props.discount} />
                                )} */}
                                {((this.props.readBookLabel && this.props.readBookPlayerLink) ||
                                    (this.props.listenToBookLabel && this.props.listenToBookPlayerLink) ||
                                    (this.props.downloadCoverImageLabel &&
                                        this.props.downloadCoverImageLink)) && (
                                    <div className={`${baseClass}__actions`}>
                                        {this.props.readBookLabel && this.props.readBookPlayerLink && (
                                            <IconButton
                                                className="product-hero__action-button"
                                                onClick={this.props.onOpenBookModal}
                                                iconId="icon_read"
                                                ariaLabel={this.props.readBookLabel}
                                            />
                                        )}
                                        {this.props.listenToBookLabel &&
                                            this.props.listenToBookPlayerLink && (
                                                <IconButton
                                                    className="product-hero__action-button"
                                                    onClick={this.props.onOpenAudioModal}
                                                    iconId="icon_listen"
                                                    ariaLabel={this.props.listenToBookLabel}
                                                />
                                            )}

                                        {this.props.downloadCoverImageLabel &&
                                            this.props.downloadCoverImageLink && (
                                                <IconLink
                                                    className="product-hero__action-button"
                                                    href={this.props.downloadCoverImageLink}
                                                    download
                                                    iconId="icon_download"
                                                    ariaLabel={this.props.downloadCoverImageLabel}
                                                    target="_blank"
                                                />
                                            )}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                    <div className={`${baseClass}__gallery-container`}>
                        <div className={`${baseClass}-background theme-bg-tertiary`} />
                        {/* Desktop icon */}
                        <div className={graphicsClasses}>
                            {this.state.isProductImageLoaded && (
                                <>
                                    {global.currentSite === "ClubGyldendalDk" ? null : (
                                        <Icon
                                            className="theme-color-primary"
                                            iconId="icon_80x48_quotation-mark"
                                            viewBox="0 0 80 48"
                                        />
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                    <div className={`${baseClass}__box`}>
                        <div className={`${baseClass}-background theme-bg-quaternary`} />
                    </div>
                </div>
                <ProductImageModal
                    onRequestClose={() => this.setState({ isModalOpen: false })}
                    isOpen={this.state.isModalOpen}
                    imageSrcSet={this.props.imageSrcSet}
                    imageFallbackSrc={this.props.imageFallbackSrc}
                />
            </>
        );
    }
}

export default ProductHero;
